<template>
  <vuetable-pagination
    ref="pagination"
    :css="css"
    @vuetable-pagination:change-page="onChangePage"
  />
</template>

<script>
import { VuetablePagination } from 'vuetable-2'

export default {
  components: {
    VuetablePagination
  },

  computed: {
    css: () => ({
      icons: {
        first: 'fa fa-angle-double-left',
        prev: 'fa fa-angle-left',
        next: 'fa fa-angle-right',
        last: 'fa fa-angle-double-right'
      }
    })
  },

  methods: {
    setPaginationData (pagination) {
      this.$refs.pagination.setPaginationData(pagination)
    },
    onChangePage (value) {
      const ref = this.$refs.pagination
      let page = value
      if (value === 'prev') {
        if (ref.isOnFirstPage) return
        page = ref.tablePagination.current_page - 1
      } else if (value === 'next') {
        if (ref.isOnLastPage) return
        page = ref.tablePagination.current_page + 1
      }
      this.$emit('change', page)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .item {
  color: inherit;
  font-size: 14px;
  padding: 2px 10px;
  text-decoration: none;
}

/deep/ .active {
  background: #18B2BD;
  border-radius: 8px;
  color: white;
}
</style>
